export const INDIAN_CLIENT_MEET_START_TIME = '15:00'
export const INDIAN_CLIENT_MEET_END_TIME = '20:00'

export const CLIENT_MEET_TIME_INTERVAL = 15;